import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { useSpecificSubcategoryStore } from "../../../hooks/useSpecificSubcategoryStore";

const columns = [
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
];

export const SubCategorySpecificModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, subcategorySelected, clearState } = props;

    const { getSpecificsubcategoriesBySubCategory } = useSpecificSubcategoryStore();

    const [loading, setLoading] = useState(false);
    const [specificSubcategories, setSpecificSubcategories] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getSpecificsubcategoriesBySubCategoryApi()
    },[])

    const getSpecificsubcategoriesBySubCategoryApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSpecificsubcategoriesBySubCategory(search, subcategorySelected.id);
            if(!response){
                setSpecificSubcategories([]);
                setLoading(false);
                return false;
            }else{
                setSpecificSubcategories(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificsubcategoriesBySubCategoryApi(term)}, 1000)
        )
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md">
            <ModalHeader
                text={'Subcategorias específicas'}
                className='positionElements'
                onCancel={closeModal}
                clearState = {clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Grid container sx={{padding:'20px'}}>
                    <Grid item container xs={12} spacing={2}>
                        <CustomTable 
                            disabled_title
                            columns={columns} 
                            loading={loading}
                            rows={specificSubcategories || []}
                            onRowClick={() => {}}
                            onSearch={onSearch}
                            RowsPerPage={5}
                            dense
                        />
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}